export default [
  "Abandon normal instruments",
  "Accept advice",
  "Accretion",
  "A line has two sides",
  "Allow an easement (an easement is the abandonment of a stricture)",
  "Always first steps",
  "Are there sections? Consider transitions",
  "Ask people to work against their better judgement",
  "Ask your body",
  "Assemble some of the elements in a group and treat the group",
  "Balance the consistency principle with the inconsistency principle",
  "Be dirty",
  "Be extravagant",
  "Be less critical more often",
  "Breathe more deeply",
  "Bridges -build -burn",
  "Cascades",
  "Change instrument roles",
  "Change nothing and continue with immaculate consistency",
  "Children -speaking -singing",
  "Cluster analysis",
  "Consider different fading systems",
  "Consult other sources -promising -unpromising",
  "Courage!",
  "Cut a vital connection",
  "Decorate, decorate",
  "Define an area as 'safe' and use it as an anchor",
  "Destroy -nothing -the most important thing",
  "Discard an axiom",
  "Disciplined self-indulgence",
  "Disconnect from desire",
  "Discover the recipes you are using and abandon them",
  "Distorting time",
  "Do nothing for as long as possible",
  "Don't be afraid of things because they're easy to do",
  "Don't be frightened of cliches",
  "Don't be frightened to display your talents",
  "Don't break the silence",
  "Don't stress one thing more than another",
  "Do something boring",
  "Do the words need changing?",
  "Do we need holes?",
  "Emphasise differences",
  "Emphasise repetitions",
  "Emphasise the flaws",
  "Fill every beat with something",
  "From nothing to more than nothing",
  "Ghost echoes",
  "Give the game away",
  "Give way to your worst impulse",
  "Go outside. Shut the door.",
  "Go slowly all the way round the outside",
  "Go to an extreme, move back to a more comfortable place",
  "Honor thy error as a hidden intention",
  "How would you have done it?",
  "Humanise something free of error",
  "Idiot glee (?)",
  "Imagine the piece as a set of disconnected events",
  "Infinitesimal gradations",
  "Intentions -nobility of -humility of -credibility of",
  "In total darkness, or in a very large room, very quietly",
  "Into the impossible",
  "Is it finished?",
  "Is the intonation correct?",
  "Is there something missing?",
  "It is quite possible (after all)",
  "Just carry on",
  "Listen to the quiet voice",
  "Look at the order in which you do things",
  "Look closely at the most embarrassing details and amplify them",
  "Lost in useless territory",
  "Lowest common denominator",
  "Make a blank valuable by putting it in an exquisite frame",
  "Make an exhaustive list of everything you might do and do the last thing on the list",
  "Make a sudden, destructive unpredictable action; incorporate",
  "Mechanicalise something idiosyncratic",
  "Mute and continue",
  "Not building a wall but making a brick",
  "Once the search is in progress, something will be found",
  "Only a part, not the whole",
  "Only one element of each kind",
  "(Organic) machinery",
  "Overtly resist change",
  "Question the heroic approach",
  "Remember .those quiet evenings",
  "Remove ambiguities and convert to specifics",
  "Remove specifics and convert to ambiguities",
  "Repetition is a form of change",
  "Retrace your steps",
  "Revaluation (a warm feeling)",
  "Reverse",
  "Short circuit(example; a man eating peas with the idea that they will improve his virility shovels them straight into his lap)",
  "Simple subtraction",
  "Simply a matter of work",
  "State the problem in words as clearly as possible",
  "Take a break",
  "Take away the elements in order of apparent non-importance",
  "The inconsistency principle",
  "The most important thing is the thing most easily forgotten",
  "The tape is now the music",
  "Think of the radio",
  "Tidy up",
  "Towards the insignificant",
  "Trust in the you of now",
  "Turn it upside down",
  "Use an old idea",
  "Use an unacceptable colour",
  "Use fewer notes",
  "Use filters",
  "Use 'unqualified' people",
  "Water",
  "What are the sections sections of? Imagine a caterpillar moving",
  "What are you really thinking about just now?",
  "What is the reality of the situation?",
  "What mistakes did you make last time?",
  "What wouldn't you do?",
  "What would your closest friend do?",
  "Work at a different speed",
  "Would anybody want it?",
  "You are an engineer",
  "You can only make one dot at a time",
  "You don't have to be ashamed of using your own ideas"
];
